module.exports = __webpack_public_path__ + "static/media/credit_store_logo_light.dccc51b5.svg";